<script setup>
defineProps({
    content: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <div
        class="content-editor prose overflow-hidden"
        v-html="content.content"
    />
</template>
